module.exports = "button {\r\n  display: block;\r\n}\r\n\r\nmat-icon {\r\n  border: 1px solid gray;\r\n  border-radius: 50%;\r\n  padding: 2px;\r\n}\r\n"